export const shouldRedirectToSessionExpired = (
  token: string | null,
  session: unknown | null
): boolean => Boolean(token) && !session;
